import React from 'react';
import styled from '@emotion/styled';

const StyledTextarea = styled.textarea`
  width: 100%;
  height: 146px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  border: none;
  margin-bottom: 10px;
  padding: 12px 16px;
  ${({ theme }) => theme.mixins.textP3};
  /* Never below 16px: iOS zooms the page on focus otherwise (#245). */
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.secondary};
  resize: none;
  transition: ${({ theme }) => theme.transitions.fast};

  &::placeholder {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.secondary};
  }

  &:focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows.outline};
  }
`;

const Textarea = ({
  name,
  placeholder,
  required = false,
  ariaLabel,
  value,
  onChange,
}) => {
  return (
    <StyledTextarea
      name={name}
      placeholder={placeholder}
      required={required}
      aria-label={ariaLabel || name}
      value={value}
      onChange={onChange}
    />
  );
};

export default Textarea;
